/* eslint-disable max-len */
import React, { useEffect, useMemo, useState, useContext } from "react";
import { Container, useScreenClass } from "react-grid-system";
import styled, { css } from "styled-components";
import Navbar, { ProfileTag } from "../components/Navbar";
import BaseStyle from "../styles/BaseStyle";
import Sidebar from "../components/Sidebar";
import SidebarMenuItem from "../components/SidebarMenuItem";
import User from "../types/User";
import Icon, { ClickableIcon } from "../components/Icon";
import Backdrop from "../components/Backdrop";
import { UserContext } from "../context/UserContext";
import { FlexGrow } from "../components/FlexBox";
import { StyledText } from "../components/Text";
import MobileStyle from "../styles/MobileStyle";
import theme from "../styles/theme";
import { StyledHr } from "../pages/Quest/Domains";
import StyledTooltip from "../components/StyledTooltip";
import { VersionContext } from "../context/VersionContext";
import ConfirmModal from "../components/ConfirmModal";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { EmptyVersion } from "../types/Version";
// import { SimonLogo } from "/assets/Simon-Logo.png";

type PageAreaProps = {
  signedIn: boolean;
  isSidebarOpen?: boolean;
  shouldShift?: boolean;
  isBehalfActive?: boolean;
} & React.HTMLProps<HTMLDivElement>;
const PageArea = styled.div<PageAreaProps>`
  // padding-top: ${({ signedIn, theme }) =>
    signedIn ? theme.navbarHeight : 0};
  padding-top: 10px;
  padding-left: ${({ signedIn, isSidebarOpen, theme }) =>
    signedIn &&
    isSidebarOpen &&
    window.location.pathname !== "/universities" &&
    window.location.pathname !== "/unauthorized"
      ? theme.sidebarWidth
      : signedIn &&
        window.location.pathname !== "/universities" &&
        window.location.pathname !== "/unauthorized"
      ? `calc(${theme.sidebarWidth} - 180px)`
      : 0};
  transition: all ${({ theme }) => theme.transitionTime.default};
  ${({ isBehalfActive }) =>
    isBehalfActive &&
    css`
      padding-top: ${({ theme }) =>
        `calc(${theme.navbarHeight} + ${theme.spacing.x8})`};
    `}
`;

const StyledContainer = styled(Container)<{ $signedIn: boolean }>`
  // padding-top: ${({ $signedIn, theme }) =>
    $signedIn ? theme.spacing.x2 : 0};
  // padding-left: ${({ $signedIn }) => !$signedIn && 0} !important;
  // padding-right: ${({ $signedIn }) => !$signedIn && 0} !important;
  max-width: ${({ $signedIn }) => !$signedIn && "100% !important"};
  color: white;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  // padding-right: 0 !important;
`;

const LogoDiv = styled.div`
  display: flex;
  flex-flow: row;
  min-height: 74px;
  align-items: center;
  // padding-bottom: 10px;
  padding-top: 10px;
`;

const Toogle = styled.div`
  position: absolute;
  right: 5%;
  left: auto;
  top: 25px;
  bottom: 92.89%;
  color: #ffffff;
`;
const ToogleCenter = styled.div`
  position: absolute;
  right: 35%;
  left: auto;
  top: 25px;
  bottom: 92.89%;
  color: #ffffff;
`;

export type Props = {
  children: React.ReactNode;
  user?: User;
  isSuperUser?: boolean;
  setSelectUniversityOpen: (x: boolean) => void;
};

function BasicLayout({ children, isSuperUser, setSelectUniversityOpen }: Props): JSX.Element {
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm", "md"].includes(screenClass),
    [screenClass]
  );
  const smallScreen = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const shouldShowSidebarByDefault = useMemo(() => !isMobile, [isMobile]);
  const [isSidebarOpen, setSidebarOpen] = useState(shouldShowSidebarByDefault);
  const { isSignedIn, setSidebarView, user } = useContext(UserContext);
  const { version } = useContext(VersionContext);
  const { isModified, setModified, isOpen, setOpen } = useContext(UserContext);
  const versionContext = useContext(VersionContext);

  const navigate = useNavigate();
  useEffect(() => {
    setSidebarOpen(shouldShowSidebarByDefault);
    setSidebarView(shouldShowSidebarByDefault);
  }, [shouldShowSidebarByDefault]);

  const onClick = () => {
    localStorage.removeItem("progress_id");
    isModified && setOpen(true);
    setModified(false);
  };
  const SetSidebarClose = () => {
    if (isMobile) {
      setSidebarOpen(false);
      setSidebarView(false);
    }
  };
  let curUser: JSX.Element = (
    <SidebarMenuItem
      isOpen={isSidebarOpen}
      name="Sign In"
      disable={false}
      to="/signin"
      margin={1.5}
      icon="circle"
      isMain
      fontSize="16px"
      click={SetSidebarClose}
    />
  );
  if (isSignedIn) {
    curUser = (
      <div
        style={{
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
        onClick={onClick}
      >
        <div>
          <LogoDiv>
            {isSidebarOpen ? (
              <>
                <FlexGrow>
                  {/* <h2 style={{ color: theme.color.darkBlueGray500}}>SIMON</h2> */}
                  <img src="/assets/Simon-Logo-Blue.png" width={200} />
                </FlexGrow>
                <FlexGrow style={{ textAlign: "end" }}>
                  <ClickableIcon
                    onClick={() => {
                      setSidebarOpen(!isSidebarOpen);
                      setSidebarView(!isSidebarOpen);
                    }}
                    size={5}
                    // rotate={270}
                    color="#5661dc"
                    name={"segment"}
                    fixedWidth={false}
                  />
                </FlexGrow>
              </>
            ) : (
              <FlexGrow style={{ textAlign: "center" }}>
                <ClickableIcon
                  onClick={() => {
                    setSidebarOpen(!isSidebarOpen);
                    setSidebarView(!isSidebarOpen);
                  }}
                  size={5}
                  color="#000000"
                  fixedWidth={false}
                  name={"menu"}
                />
              </FlexGrow>
            )}
          </LogoDiv>
          {isSidebarOpen && (
            <div
              style={{
                overflow: "auto",
                maxHeight: "100vh",
                color: "#000000",
                background: "#ecf5fe",
                borderRadius: "7px 7px 0px 0px",
                padding: "15px 15px",
                // alignItems: "center",
                display: "flex",
                // justifyContent: "center",
                flexDirection: "column",
                boxShadow: "inset #0046ff12 0px 2px 3px 3px",
                gap: 2,
                // borderBottom: "5px solid white",
              }}
            >
              <div
                className="reduce_opct_onhover"
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                Selected 
                {localStorage.getItem("university") && localStorage.getItem("selectedProgram") && (
                  <div
                    style={{
                      fontSize: 11,
                      display: "flex",
                      alignItems: "center",
                      justifyContent:'end',
                      color: "blue",
                      // border: "1px solid red",
                      // padding: "1px 3px",
                      borderRadius: 5,
                    }}
                    onClick={() => {
                      // setSelectUniversityOpen(true)
                      // localStorage.removeItem("university");
                      // localStorage.removeItem("selectedProgram");
                      // localStorage.removeItem("selectedVersion");
                      // localStorage.removeItem("active_version");
                      // localStorage.removeItem("allVersions");
                      // versionContext.setCurrentVersion(EmptyVersion);
                      window.location.pathname = "/universities";
                    }}
                  >
                    <Icon
                      style={{ verticalAlign: "middle" }}
                      // ml={2}
                      name={"restart_alt"}
                    />
                    Change Program
                  </div>
                )}
              </div>
              {version.version_number === 0 ? (
                <>
                  <div style={{ fontSize: 12 }}>
                    University : {localStorage.getItem("university") || "_ _"}
                  </div>
                  <div style={{ fontSize: 12 }}>
                    Program : {localStorage.getItem("selectedProgram") || "_ _"}
                  </div>
                </>
              ) : (
                <>
                  <div style={{ fontSize: 12 }}>
                    {version?.university} : {version?.title}
                  </div>
                  <div style={{ fontSize: 12 }}>
                    Program : {localStorage.getItem("selectedProgram")}
                  </div>
                  <div style={{ fontSize: 12 }}>
                    Version : {version?.display_version} ({version.status})
                  </div>
                </>
              )}
            </div>
          )}
          <StyledHr style={{ borderColor: "#dadada59" }} />

          <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Version Management"
            disable={false}
            to={!isModified && "/curriculum/version"}
            margin={1}
            icon="check_box"
            isMain
            fontSize="16px"
            click={() => {
              SetSidebarClose();
              // localStorage.removeItem("university")
              // localStorage.removeItem("selectedProgram")
            }}
          />
          {/* <SidebarMenuItem
          isOpen={isSidebarOpen}
          name="Export & Import"
          disable={version.university === ""}
          to={!isModified && "/curriculum/export"}
          margin={1}
          icon="import_export"
          isMain
          fontSize="16px"
          click={SetSidebarClose}
        /> */}
          <StyledHr style={{ borderColor: "#dadada59" }} />
          <SidebarMenuItem
            isOpen={isSidebarOpen}
            disable={version.university === ""}
            name="View Competencies"
            to={!isModified && "/view/competencies"}
            margin={1}
            icon="dashboard"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          />

          <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Modify Competencies"
            disable={version.university === ""}
            to={
              isModified
                ? window.location.pathname.includes("/modify/competency") &&
                  window.location.pathname
                : "/modify/competency"
            }
            margin={1}
            icon="edit"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          />
          {user.role !== "instructor" && (
            <>
              <SidebarMenuItem
                isOpen={isSidebarOpen}
                name="Create Competency"
                disable={version.university === ""}
                to={!isModified && "/create/competency"}
                margin={1}
                icon="add_box"
                isMain
                fontSize="16px"
                click={SetSidebarClose}
              />
            </>
          )}
          <StyledHr style={{ borderColor: "#dadada59" }} />
          <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Modify Pillar"
            disable={version.university === ""}
            to={
              isModified
                ? window.location.pathname.includes("/modify/pillar") &&
                  window.location.pathname
                : "/modify/pillar"
            }
            margin={1}
            icon="edit"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          >
            <StyledTooltip
              header="Includes:"
              description="Subdomain, Area and Topic"
            >
              <div>
                <Icon
                  style={{ verticalAlign: "middle" }}
                  ml={2}
                  name={"info"}
                />
              </div>
            </StyledTooltip>
          </SidebarMenuItem>
          {user.role !== "instructor" && (
            <SidebarMenuItem
              isOpen={isSidebarOpen}
              name="Create Pillar"
              disable={version.university === ""}
              to={!isModified && "/create/pillar"}
              margin={1}
              icon="add_box"
              isMain
              fontSize="16px"
              click={SetSidebarClose}
            />
          )}
          <StyledHr style={{ borderColor: "#dadada59" }} />
          {/* <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Semester Plan"
            disable={version.university === ""}
            to={!isModified && "/semester-plan"}
            margin={1}
            icon="note_alt"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          />
          <StyledHr style={{ borderColor: "#dadada59" }} /> */}
          <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Competency History"
            disable={false}
            to={!isModified && "/version-competency"}
            margin={1}
            icon="access_time_icon"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          />
          <StyledHr style={{ borderColor: "#dadada59" }} />
          <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Curriculum Documentation"
            disable={false}
            to={!isModified && "/pillar-doc"}
            margin={1}
            icon="folder_special_icon"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          />
          <StyledHr style={{ borderColor: "#dadada59" }} />
          <SidebarMenuItem
            isOpen={isSidebarOpen}
            name="Change History"
            disable={version.university === ""}
            to={!isModified && "/change-history"}
            margin={1}
            icon="manage_history_icon"
            isMain
            fontSize="16px"
            click={SetSidebarClose}
          />
          <StyledHr style={{ borderColor: "#dadada59" }} />

          {/* {isSuperUser && (
            <SidebarMenuItem
              isOpen={isSidebarOpen}
              name="Switch University"
              disable={false}
              to={!isModified && "/universities"}
              margin={1}
              icon="account_balance_icon"
              isMain
              fontSize="16px"
              click={SetSidebarClose}
            />
          )} */}
        </div>
        {isSidebarOpen ? (
          <Button
            className="reduce_opct_onhover"
            isOutline
            style={{
              position: "sticky",
              background: "white",
              color: theme.color.lightBlueGray700,
              bottom: 10,
              // width: "100%",
              padding: "7px",
              border: `2px solid ${theme.color.lightBlueGray300}`,
              borderRadius: 5,
            }}
            onClick={() => navigate("/signout")}
          >
            <Icon
              style={{ verticalAlign: "middle" }}
              mr={1}
              name={"power_settings_new"}
            />
            Sign out
          </Button>
        ) : (
          <span
            onClick={() => navigate("/signout")}
            className="reduce_opct_onhover"
          >
            <Icon
              style={{
                verticalAlign: "middle",
                position: "absolute",
                color: theme.color.lightBlueGray700,
                bottom: 25,
                left: 18,
              }}
              size={5}
              name={"power_settings_new"}
            />
          </span>
        )}
      </div>
    );
  }
  return (
    <>
      {smallScreen ? <MobileStyle /> : <BaseStyle />}
      <Backdrop
        show={isSidebarOpen && isMobile}
        clicked={() => {
          setSidebarOpen(false);
          setSidebarView(false);
        }}
      />
      {isSignedIn &&
        window.location.pathname !== "/universities" &&
        window.location.pathname !== "/unauthorized" && (
          <>
            {/* <Navbar
            isOpen={isSidebarOpen}
            onSidebarToggle={() => {
              setSidebarOpen(!isSidebarOpen);
              setSidebarView(!isSidebarOpen);
            }}
            showSignout={!isSidebarOpen}
          /> */}
            <Sidebar isOpen={isSidebarOpen}>{curUser}</Sidebar>
          </>
        )}
      <PageArea
        signedIn={isSignedIn}
        isSidebarOpen={isSidebarOpen}
        shouldShift={shouldShowSidebarByDefault}
      >
        <StyledContainer style={{ overflow: "none" }} $signedIn={isSignedIn}>
          {children}
        </StyledContainer>
      </PageArea>
    </>
  );
}

export default BasicLayout;
